(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('scripts-releases', {
                parent: 'update_management',
                url: '/scripts-releases?sort&search&objectType',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.scriptsReleases.home.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/scripts-releases/scripts-releases.html',
                        controller: 'ScriptsReleasesController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '0',
                        squash: true
                    },
                    sort: {
                        value: [],
                        squash: true
                    },
                    search: {
                        value: '',
                        squash: true
                    },
                    objectType: {
                        value: '-1',
                        squash: true
                    },
                    scriptsTypes: {
                        value: '-1',
                        squash: true
                    },
                    predicates: {}
                }, resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicates: $stateParams.predicates,
                            search: $stateParams.search,
                            objectType: $stateParams.objectType,
                            scriptsTypes: $stateParams.scriptsTypes
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('scriptsReleases');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('scripts-releases-detail', {
                parent: 'scripts-releases',
                url: '/scripts-releases/{id}',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.scriptsReleases.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/scripts-releases/scripts-releases-detail.html',
                        controller: 'ScriptsReleasesDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('scriptsReleases');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ScriptsReleases', function ($stateParams, ScriptsReleases) {
                        return ScriptsReleases.get({id: $stateParams.id});
                    }]
                }
            })
            .state('scripts-releases-new', {
                parent: 'scripts-releases',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.scriptsReleases.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/scripts-releases/scripts-releases-dialog.html',
                        controller: 'ScriptsReleasesDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('scriptsReleases');
                        return $translate.refresh();
                    }], entity: function () {
                        return {
                            scriptsReleaseName: null,
                            scriptsReleaseDescription: null,
                            isActive: false,
                            scriptsReleaseVersion: null,
                            id: null
                        };
                    }
                }
            })
            .state('scripts-releases-edit', {
                parent: 'scripts-releases',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.scriptsReleases.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/scripts-releases/scripts-releases-dialog.html',
                        controller: 'ScriptsReleasesDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('scriptsReleases');
                        return $translate.refresh();
                    }], entity: ['$stateParams', 'ScriptsReleases', function ($stateParams, ScriptsReleases) {
                        return ScriptsReleases.get({id: $stateParams.id});

                    }]
                }
            })
            .state('scripts-releases-upgrade', {
                parent: 'scripts-releases',
                url: '/{id}/upgrade',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.scriptsReleases.upgrade.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/scripts-releases/scripts-releases-upgrade.html',
                        controller: 'ScriptsReleasesDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('scriptsReleases');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ScriptsReleases', '$q', function ($stateParams, ScriptsReleases, $q) {
                        var scriptsRelease = $q.defer();
                        ScriptsReleases.get({id: $stateParams.id}).$promise.then(function (data) {
                            data.id = null;
                            scriptsRelease.resolve(data);
                        });
                        return scriptsRelease.promise;
                    }]
                }
            })
            .state('scripts-releases.delete', {
                parent: 'scripts-releases',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/scripts-releases/scripts-releases-delete-dialog.html',
                        controller: 'ScriptsReleasesDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ScriptsReleases', function (ScriptsReleases) {
                                return ScriptsReleases.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('scripts-releases', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('scripts-releases.enable', {
                parent: 'scripts-releases',
                url: '/{id}/enable',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/scripts-releases/scripts-releases-enable-dialog.html',
                        controller: 'ScriptsReleasesEnableController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ScriptsReleases', function (ScriptsReleases) {
                                return ScriptsReleases.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('scripts-releases', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
